/*
 * @Author: 王枫叶
 * @Date: 2020-09-28 16:52:13
 * @LastEditors: 王枫叶
 * @LastEditTime: 2020-09-30 18:00:06
 */
import UserList from "../views/user/userList";
import UserLog from "../views/user/userLog";
import UserIpBlock from "../views/user/userIpBlock";
import UserWatch from "../views/user/userWatch";
import UserReport from "../views/user/userReport";
// import CommonQuestion from '../views/user/commonQuestion'
import BlackList from "../views/user/blackList";
// import UserRecommendation from "../views/user/userRecommendation";
import FeedbackList from "../views/user/feedbackList";
// import UserFans from "../views/user/userFollow";
import Main from "../views/main";

const UserRouter = {
  path: "/user-list",
  component: Main,
  title: "用户管理",
  icon: "el-icon-user-solid",
  meta: { keepAlive: false },
  children: [
    {
      path: "/user-list",
      component: UserList,
      name: "userList",
      title: "用户列表",
      meta: { title: "用户列表", keepAlive: false },
    },
    {
      path: "/user-log",
      component: UserLog,
      name: "userLog",
      title: "用户登陆日志",
      meta: { title: "用户登陆日志", keepAlive: false },
    },
    {
      path: "/user-ip-block",
      component: UserIpBlock,
      name: "userIpBlock",
      title: "用户IP限制",
      meta: { title: "用户IP限制", keepAlive: false },
    },
    {
      path: "/user-watch",
      component: UserWatch,
      name: "userWatch",
      title: "用户观看列表",
      meta: { title: "用户观看列表", keepAlive: false },
    },
    //{
    //  path: '/common-question',
    //  component: CommonQuestion,
    //  name: 'commonQuestion',
    //  title: '用户常见问题',
    //  meta: { title: '用户常见问题'  ,keepAlive:true}
    //},
    {
      path: "/user-report",
      component: UserReport,
      name: "userReport",
      title: "用户举报列表",
      meta: { title: "用户举报列表", keepAlive: false },
    },
    {
      path: "/black-list",
      component: BlackList,
      name: "blackList",
      title: "黑名单列表",
      meta: { title: "黑名单列表", keepAlive: false },
    },
    // {
    //   path: "/user-recommendation",
    //   component: UserRecommendation,
    //   name: "userRecommendation",
    //   title: "用户推荐列表",
    //   meta: { title: "用户推荐列表", keepAlive: false },
    // },
    {
      path: "/feedback-list",
      component: FeedbackList,
      name: "feedbackList",
      title: "用户反馈列表",
      meta: { title: "用户反馈列表", keepAlive: false },
    },
    // {
    //   path: "/user-fans",
    //   component: UserFans,
    //   name: "userFans",
    //   title: "用户自动关注配置",
    //   meta: { title: "用户自动关注配置", keepAlive: false },
    // },
  ],
};
export default UserRouter;
